import { Myprofiles } from '../api/fetchMyProfiles';
import { QueueConfig } from '../api/fetchQueueConfig';
import { IPDConfigReponse } from '../api/getIpdConfigData';
import { SearchType } from '../components/globalsearch/GlobalSearchModal';

export const LS_KEY_MY_PROFILE = 'myProfile';
export const LS_KEY_MY_ACTIVE_ID = 'mActiveId';
export const LS_KEY_MY_GROUP_ACCESS_ID = 'mGroupAccessId';
export const LS_DEP_KEY_DOC_ACTIVE_ID = 'activeId';
export const LS_KEY_MINIMIZE_DOC_ASSIST = 'minimizeDocAssist';
export const LS_MY_PROFILE_LIST = 'myProfileList';
export const LS_TEMP_NEW_AUTH_FLOW = '_temp_new_auth_flow';
export const LS_LAST_FINAL_GLASS_PRESCRIPTION_FROM = 'ls_last_final_glass_prescription_from';
export const LS_GLOBAL_SEARCH_PARAM = 'ls_global_search_param';
const LS_SCHEDULE_SIDEBAR_COLLAPSED = 'ls_schedule_sidebar_collapsed';
const LS_SCHEDULE_DOCTOR_LIST = 'ls_schedule_doctor_list';
const LS_SCHEDULE_SLOT_DURATION = 'ls_schedule_slot_duration';
const LS_QUEUE_CONFIG = 'queue-conf';
const LS_IPD_CONFIG = 'ipd-conf';
const LS_IPD_LAST_UPDATED = 'ipd-last-updated';
const LS_REFERRAL_SETUP = 'referral-setup';
const LS_IS_ALL_CLINICS = 'isAllClinics';

export const setMActiveId = (id?: string): void => {
    if (!id) {
        // client doesn't know in which profile it is
        localStorage.removeItem(LS_KEY_MY_ACTIVE_ID);

        // @deprecated
        localStorage.removeItem(LS_DEP_KEY_DOC_ACTIVE_ID);
        return;
    }
    localStorage.setItem(LS_KEY_MY_ACTIVE_ID, id);
};

export const getMActiveId = (): string | undefined => {
    return localStorage.getItem(LS_KEY_MY_ACTIVE_ID) || undefined;
};

export const getDefiniteMActiveId = (): string => {
    return localStorage.getItem(LS_KEY_MY_ACTIVE_ID) as string;
};

/**
 * UI state should maintain this at compoenent level, which doctor I am in
 * @returns @deprecated
 */
export const getActiveDoctorId = (): string | undefined => {
    return localStorage.getItem(LS_DEP_KEY_DOC_ACTIVE_ID) || undefined;
};

export const setMyProfileList = (profiles?: Myprofiles['data']['users']): void => {
    localStorage.setItem(LS_MY_PROFILE_LIST, JSON.stringify(profiles));
};

export const getMyProfileList = (): Myprofiles['data']['users'] | undefined => {
    const profiles = localStorage.getItem(LS_MY_PROFILE_LIST);
    if (!profiles) {
        return undefined;
    }
    return JSON.parse(profiles);
};

export const clearLocalStorage = (): void => {
    localStorage.clear();
};

export const getLastFinalGlassPrescription = (): string | undefined => {
    return localStorage.getItem(LS_LAST_FINAL_GLASS_PRESCRIPTION_FROM) || undefined;
};

export const setLastFinalGlassPrescription = (value: string): void => {
    localStorage.setItem(LS_LAST_FINAL_GLASS_PRESCRIPTION_FROM, value);
};

export const setScheduleSidebarCollapsed = (value: boolean): void => {
    localStorage.setItem(LS_SCHEDULE_SIDEBAR_COLLAPSED, value.toString());
};

export const getScheduleSidebarCollapsed = (): boolean => {
    return localStorage.getItem(LS_SCHEDULE_SIDEBAR_COLLAPSED) === 'true';
};

export const setScheduleDoctorList = (value: string[]): void => {
    localStorage.setItem(LS_SCHEDULE_DOCTOR_LIST, JSON.stringify(value));
};

export const getScheduleDoctorList = (): string[] | undefined => {
    return JSON.parse(localStorage.getItem(LS_SCHEDULE_DOCTOR_LIST) || '[]') || undefined;
};

export const getQueueConfig = (): QueueConfig => {
    return JSON.parse(localStorage.getItem(LS_QUEUE_CONFIG) || '{}');
};

export const getScheduleSlotDuration = (): number => {
    return parseInt(localStorage.getItem(LS_SCHEDULE_SLOT_DURATION) || '10', 10);
};

export const setScheduleSlotDuration = (value: number): void => {
    localStorage.setItem(LS_SCHEDULE_SLOT_DURATION, value.toString());
};

export const getIpdConfig = (): IPDConfigReponse['data'] | undefined => {
    return JSON.parse(localStorage.getItem(LS_IPD_CONFIG) || '{}');
};

export const setIpdConfig = (config: IPDConfigReponse['data']): void => {
    localStorage.setItem(LS_IPD_CONFIG, JSON.stringify(config));
    setIpdLastUpdated(new Date().toISOString());
};

export const getIpdLastUpdated = (): string | undefined => {
    return localStorage.getItem(LS_IPD_LAST_UPDATED) || undefined;
};

export const setIpdLastUpdated = (value: string): void => {
    // localStorage.setItem(LS_IPD_LAST_UPDATED, value);
    // todo: fix the diff updates
    localStorage.removeItem(LS_IPD_LAST_UPDATED);
};

export const getReferralSetup = (): boolean => {
    return localStorage.getItem(LS_REFERRAL_SETUP) === 'true';
};

export const setReferralSetup = (value: boolean): void => {
    localStorage.setItem(LS_REFERRAL_SETUP, value.toString());
};

export const getMyGroupAccessId = (): string | undefined => {
    return localStorage.getItem(LS_KEY_MY_GROUP_ACCESS_ID) || undefined;
};

export const setMyGroupAccessId = (id?: string): void => {
    if (!id) {
        localStorage.removeItem(LS_KEY_MY_GROUP_ACCESS_ID);
        return;
    }
    localStorage.setItem(LS_KEY_MY_GROUP_ACCESS_ID, id);
};

export const isOnNewQueueView = (): boolean => {
    return ((window.localStorage.getItem('isNewView') || 'true') as string) === 'true';
};

export const isAllClinics = (): boolean => {
    return ((window.localStorage.getItem(LS_IS_ALL_CLINICS) || 'false') as string) === 'true';
};
export const setIsAllClinics = (value: boolean): void => {
    window.localStorage.setItem(LS_IS_ALL_CLINICS, value.toString());
};

export const getGlobalSearchParam = (): SearchType | undefined => {
    return (localStorage.getItem(LS_GLOBAL_SEARCH_PARAM) as SearchType) || undefined;
};

export const setGlobalSearchParam = (val: SearchType): void => {
    localStorage.setItem(LS_GLOBAL_SEARCH_PARAM, val);
};
